const strings = {
	en: {
		title: 'Terms and conditions',
	},
	es: {
		title: 'Términos y condiciones',
	}
}

export default strings;